import {useContext, useState} from "react";
import Toast from "./Toast";
import { v4 as uuidv4 } from 'uuid';
import {NotificationContext} from "../../contexts/NotificationContext";

function Notifications() {
	const {toasts} = useContext(NotificationContext);

	return (
		<div className={"toast-container position-fixed"} style={{zIndex: "100000", right: 5, top: 4}}>
			{toasts.map(value => {
				return <Toast message={value.message} description={value.description} key={value.id} id={value.id} />;
			})}
		</div>
	);
}

export default Notifications;